import moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { formatLinkString } from "../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faUsers, faClock, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import "./styleCard.css"; // Réutilise les styles modernes définis précédemment

const JobCardOld = (props) => {
  const { job } = props;
  const { t } = useTranslation();

  return (
    <div className="card-job-modern hover-up h-100">
      <Link to={`/job/${job.slug}/details/`} className="d-flex flex-column h-100 text-decoration-none">
        
        {/* En-tête : Logo + Badge Type */}
        <div className="card-job-header">
          <div className="card-job-image-box">
            <img
              src={
                job?.image
                  ? formatLinkString(job?.image)
                  : "/assets/imgs/page/homepage2/logo.png"
              }
              alt={job.title}
              className="img-fluid"
            />
          </div>
          <div className="d-flex gap-1">
             {/* Badge Type de contrat */}
             <span className="badge-job badge-blue">
                {job.type || <FontAwesomeIcon icon={faBriefcase} />}
             </span>
             {/* Badge Fermé si nécessaire */}
             {job.closed && (
                <span className="badge-job badge-red">{t("jobExpired")}</span>
             )}
          </div>
        </div>

        {/* Corps : Titre et Localisation */}
        <div className="card-job-body flex-grow-1">
          <h5 className="job-title mb-2" title={job.title}>
            {job.title}
          </h5>
          
          <div className="job-meta-list mb-3">
            <div className="meta-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="icon-muted" />
              <span>
                {job.city?.name ? `${job.country?.name}, ${job.city?.name}` : job.country?.name}
              </span>
            </div>
          </div>
        </div>

        {/* Pied de carte : Stats compactes */}
        <div className="card-job-footer mt-auto pt-3 border-top">
           <div className="d-flex justify-content-between align-items-center small text-muted">
              
              {/* Places / Candidats */}
              <div title={`${t("textNberPlaces")}: ${job.required}`}>
                 <FontAwesomeIcon icon={faUsers} className="text-primary me-1" />
                 <span className="fw-bold text-dark">{job.required}</span> Postes
              </div>
              

              {/* Date */}
              <div className="text-end">
                 <FontAwesomeIcon icon={faClock} className="me-1 icon-muted" />
                 {moment(job?.created_at).fromNow(true)}
              </div>

           </div>
           
           {/* Candidatures reçues (Optionnel, si vous voulez l'afficher) */}
           {/* <div className="mt-1 font-xs text-muted">
               {job.submitted} candidatures
           </div> */}
        </div>

      </Link>
    </div>
  );
};

export default JobCardOld;